var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppreciation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.417187 19.6415V19.8415H0.617188H15.869H15.8694H16.0694V19.6415V8.08027V7.99305L16.0054 7.9337L8.3797 0.853434L8.24363 0.727091L8.10755 0.853428L0.481112 7.9337L0.417187 7.99304V8.08027V19.6415ZM15.1771 8.41071V18.9111H1.30912L1.30878 8.41071L8.24326 1.97301L15.1771 8.41071Z",
    fill: "#613ED2",
    stroke: "#613ED2",
    strokeWidth: 0.4,
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29693 11.166L5.29693 19.6394M11.2282 11.166L11.2282 19.6394M4.49609 11.6091H12.0259",
    stroke: "#613ED2",
    strokeWidth: 1.6,
    id: "path2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6953 19.2924L22.6953 5.79688",
    stroke: "#613ED2",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0156 9.47747L22.6962 5.79688L26.3768 9.47747",
    stroke: "#613ED2",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0323699
    },
    d: "M 0.24473444,13.959538 0.24669431,7.8982659 4.2264006,4.2080925 C 6.4152393,2.1784971 8.2258814,0.51960856 8.2500501,0.52167349 8.2742188,0.52373842 10.087671,2.1910676 12.279944,4.2268496 l 3.985952,3.7014213 V 13.97454 20.020809 H 8.2543353 0.24277457 Z m 4.27087246,0.817341 v -3.949133 h 3.7549133 3.7549138 v 3.949133 3.949133 h 1.489117 1.489117 l -0.0082,-5.122544 -0.0082,-5.1225431 -2.789246,-2.5895954 C 10.663951,4.467052 9.1467979,3.0581786 8.8265847,2.7604996 L 8.2443786,2.2192651 4.8747906,5.3474659 1.5052023,8.4756667 v 5.1251723 5.125173 h 1.5052023 1.5052023 z m 5.9236991,0.776878 V 12.381503 H 8.2543353 6.0693642 v 3.172254 3.172255 h 2.1849711 2.1849707 z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0323699
    },
    d: "m 22.56185,19.958171 c -0.222131,-0.05408 -0.375678,-0.176494 -0.489856,-0.390541 -0.0582,-0.109106 -0.06103,-0.334321 -0.07662,-6.090981 l -0.01619,-5.9776871 -1.283365,1.2706792 c -0.764644,0.7570854 -1.332199,1.2938529 -1.404185,1.3280119 -0.182695,0.0867 -0.486655,0.05906 -0.658242,-0.05985 -0.251429,-0.1742409 -0.361639,-0.54235 -0.245951,-0.8214977 0.03458,-0.083426 0.647795,-0.7189989 1.998844,-2.0717034 1.852712,-1.8549817 1.957276,-1.9537897 2.117175,-2.0006363 0.17653,-0.051719 0.347029,-0.039104 0.495377,0.036652 0.117108,0.059803 3.92124,3.8803628 3.987696,4.0049159 0.14081,0.2639099 0.03336,0.6636861 -0.227842,0.8476605 -0.172966,0.12183 -0.482042,0.153216 -0.655371,0.06655 -0.06065,-0.03032 -0.696564,-0.6399569 -1.413154,-1.3547441 l -1.30289,-1.2996127 v 5.9582458 c 0,6.700165 0.02114,6.151521 -0.24605,6.386709 -0.08329,0.07332 -0.202816,0.140889 -0.286472,0.161953 -0.15771,0.03971 -0.154217,0.03964 -0.292911,0.0059 z",
    id: "path6"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppreciation);
export default __webpack_public_path__ + "static/media/appreciation.1c1a2c61cf35cd015960cb7262bd175f.svg";
export { ForwardRef as ReactComponent };